import React, {useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import LoginFormContainer from "./login-form-container";
import {Box, Button, Link, Slide, Typography} from "@material-ui/core";
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import useGetBeiAnData from "../../services/useGetBeiAnData";

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100vh',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      minHeight: '100vh',
      flexDirection: 'column',
    }
  },
  left: {
    width: '35%',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    backgroundColor: '#fff',
    height: '100%',
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: '1 0 auto',
      minHeight: 350,
    }
  },
  logo: {
    position: 'absolute',
    top: 15,
    left: '50%',
    transform: 'translateX(-50%)'
  },
  loginForm: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loginFormMessage: {
    width: '80%',
  },
  right: {
    height: '100%',
    width: '65%',
    backgroundColor: '#eee',
    backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/background.jpg'})`,
    backgroundSize: 'cover',
    backgroundPosition: '0 100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: '1 0 auto'
    }
  },
  introduction: {
    width: `calc(100% - ${theme.spacing(2) * 2}px)`,
    maxWidth: 800,
    padding: theme.spacing(3, 8),
    margin: theme.spacing(2),
    backgroundColor: 'rgba(255,255,255,0.8)',
    borderRadius: 5,
    borderLeft: `solid 5px rgba(255,131,0,0.5)`,
    '& p, & a': {
      margin: theme.spacing(4, 0),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 4),
    }
  },
  link: {
    display: 'block'
  }
}));

const Login: React.FC = () => {
  const classes = useStyles();
  const [showLoginForm, setShowLoginForm] = useState(false);
  const {
    text,
    link
  } = useGetBeiAnData();

  return (
    <div className={classes.root} >
      <div className={classes.left}>
        {
          showLoginForm &&
          <Slide in={true} direction={'left'}>
            <div className={classes.loginForm}>
              <LoginFormContainer/>
            </div>
          </Slide>
        }
        {
          !showLoginForm &&
          <div>
            <Typography variant={'h5'} component={'h1'}>
              <Box fontWeight={700} mb={1}>
                CIT-CoPT
              </Box>
            </Typography>
            <Button color={'primary'} startIcon={<RecentActorsIcon/>} onClick={() => setShowLoginForm(true)} style={{marginLeft: -4}}>
              登录
            </Button>
          </div>
        }
      </div>

      <div className={classes.right}>
        <div className={classes.introduction}>
          <Typography variant={"body1"} component={'p'}>
            CIT-CoPT（Capture sequencing for Identifying Targets for Colorectal Personalized Therapy）是基于结直肠癌基因测序分析的临床个体化精准治疗新技术平台。平台建立了结直肠癌药物-靶标基因列表，对病人肿瘤样本进行针对性的外显子捕获测序，获取肿瘤基因突变谱。基于患者突变信息以及药物-靶标基因生物信息数据库，筛选病人可能的治疗响应药物。在体外利用来自病人肿瘤的类器官和异种移植培养模型，验证患者癌细胞对所选药物的敏感性，明确最有效的药物或药物组合。
          </Typography>
          <Typography variant={"body1"} component={'p'}>
            本平台通过分析结直肠癌病人基因组变异，找到适于每个病人的特异性药物靶点，推荐相应药物，朝向结直肠癌的精准医疗迈进。
          </Typography>
          <Typography variant={"body2"} component={'p'}>
            免责声明：本站提供的所有工具及分析结果仅供医生在诊疗过程中参考，其输出结果不能替代医生的专业临床判断、体格检查、实验室检测及影像学评估。最终诊断及治疗方案的决定权完全属于主治医师。因依赖本站信息或工具建议而导致的包括但不限于误诊、错诊、医疗事故、治疗延误或任何其他损害，本站运营方一概不承担任何法律责任。
          </Typography>
          <Link href={link} target={'_blank'} rel={'noreferrer noopener'} className={classes.link}>
            {text}
          </Link>
        </div>
      </div>

    </div>
  )
};

export default Login
